import { TwoFactorForm } from '@/components/forms/TwoFactorForm'

export default function TwoFactorPage() {
  return <TwoFactorForm />
}

